export default "__VITE_ASSET__c36cc5ee__"